import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import CategoryDropDown from './CategoryDropDown';
import { insertCategoryIdtoUrl, ROUTES } from '../../../constants/Routes';

const BusinessCategoryItem = ({ category }) => {
  const { id, name } = category;

  return (
    <Link
      to={insertCategoryIdtoUrl(ROUTES.BUSINESS_CATEGORY_FILTER, id)}
      className="d-inline-block category-item bg-white"
    >
      {name}
    </Link>
  );
};

const mapCategories = (categories) => {
  return categories.map(category => (
    <BusinessCategoryItem
      key={category.id}
      category={category}
    />
  ));
}

const BusinessCategoryList = ({ categories, dropDown }) => {
  const categoriesLength = categories.length;

  if (!dropDown && categoriesLength > 2) {
    const firstTwoCategories = [...categories].splice(0, 2);
    const otherCategories = [...categories].splice(2, categoriesLength);
    const displayCategory = mapCategories(firstTwoCategories);

    return (
      <Fragment>
        {displayCategory}
        <CategoryDropDown
          categories={otherCategories}
        />
      </Fragment>
    )
  }

  return mapCategories(categories);
}

export default BusinessCategoryList;

BusinessCategoryList.propTypes = {
  categories: PropTypes.array,
  dropDown: PropTypes.oneOf([true, undefined]),
};

BusinessCategoryItem.propTypes = {
  category: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/components/businesses/category/BusinessCategoryRow.js